var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        top: "8vh",
        title: _vm.actionConfigInfo.label,
        visible: _vm.fileVisiable,
        width: "80%",
        "append-to-body": "",
        "close-on-click-modal": false,
        "before-close": _vm.handleCloseAction,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.fileVisiable = $event
        },
      },
    },
    [
      _c("div", { staticClass: "annexes-info" }, [
        _c(
          "div",
          { staticClass: "annexes" },
          [
            _c(
              "el-upload",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showRepeal,
                    expression: "showRepeal",
                  },
                ],
                staticClass: "upload-demo",
                attrs: {
                  multiple: "",
                  drag: "",
                  data: _vm.resData,
                  "show-file-list": false,
                  "on-success": _vm.onSuccess,
                  "on-error": _vm.onError,
                  "before-upload": _vm.onProgress,
                  headers: _vm.uploadHeaders,
                  action: _vm.uploadUrl,
                },
              },
              [
                _c("i", { staticClass: "el-icon-upload" }),
                _c("div", { staticClass: "el-upload__text" }, [
                  _vm._v(" " + _vm._s(_vm.$t("FormOfSet.uploadDrag")) + " "),
                  _c("em", [
                    _vm._v(_vm._s(_vm.$t("configMoudle.clickUpload"))),
                  ]),
                ]),
              ]
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "annexes-content" },
          [
            _c("annexes-list", {
              ref: "annexesListRef",
              attrs: {
                detailConfig: _vm.config,
                height: 400,
                showDel: _vm.showDel,
                tableData: _vm.annexesList,
              },
              on: {
                bindAnnexesDownload: _vm.bindAnnexesDownload,
                bindAnnexesDel: _vm.bindAnnexesDel,
                bindAnnexesView: _vm.bindAnnexesView,
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.batchDownload },
            },
            [_vm._v(_vm._s(_vm.$t("listOfSet.batchExport")))]
          ),
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("feedback.closed")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }